// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__qThVj {
  padding: 1rem; }

.styles_header__qW1tD {
  margin-bottom: 2rem; }

.styles_title__THX9i {
  margin-bottom: 1rem; }

.styles_description__xzw-8 {
  color: var(--text-secondary); }

.styles_content__fKFXO {
  gap: 1rem;
  margin-top: 1rem; }

.styles_item__s6AxQ {
  margin: 0.5rem 0;
  padding: 0.5rem;
  border-radius: 4px; }

.styles_voteItem__qk6Jj {
  border: 1px solid #8080805c;
  transition: all 0.2s ease; }
  .styles_voteItem__qk6Jj.styles_upvote__05cwj {
    border-color: #72ababb8;
    background: rgba(114, 171, 171, 0.05); }
  .styles_voteItem__qk6Jj.styles_downvote__PXITx {
    border-color: #721446;
    background: rgba(114, 20, 70, 0.05); }

.styles_commentInput__mm96V {
  margin-top: 1rem;
  border: 1px solid #8080805c;
  display: flex; }

.styles_headerCard__DmzDu > div {
  padding-bottom: 3rem;
  min-height: 12rem; }
  .styles_headerCard__DmzDu > div > div:last-child {
    height: 2.5rem;
    padding-bottom: 0.5rem; }
    .styles_headerCard__DmzDu > div > div:last-child button {
      margin: 0.5rem; }

.styles_votesCard__mGWSL, .styles_commentsCard__8dzYj {
  max-height: 36vh; }

.styles_rightPanel__6QSwN {
  padding-bottom: 3rem;
  justify-content: space-evenly; }
`, "",{"version":3,"sources":["webpack://./src/modules/mapal/submodules/features/components/screens/FeatureScreen/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,aAAa,EAAA;;AAGjB;EACI,mBAAmB,EAAA;;AAGvB;EACI,mBAAmB,EAAA;;AAGvB;EACI,4BAA4B,EAAA;;AAGhC;EACI,SAAS;EACT,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB;EAChB,eAAe;EACf,kBAAkB,EAAA;;AAGtB;EACI,2BChBc;EDiBd,yBAAyB,EAAA;EAF7B;IAKQ,uBCOgB;IDNhB,qCCMgB,EAAA;EDZxB;IAUQ,qBCSa;IDRb,mCCQa,EAAA;;ADJrB;EACI,gBAAgB;EAChB,2BChCc;EDiCd,aAAa,EAAA;;AAGjB;EAEQ,oBAAoB;EACpB,iBAAiB,EAAA;EAHzB;IAKY,cAAc;IACd,sBAAsB,EAAA;IANlC;MAQgB,cAAc,EAAA;;AAO9B;EACI,gBAAgB,EAAA;;AAIpB;EACI,oBAAoB;EACpB,6BAA6B,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.container {\n    padding: 1rem;\n}\n\n.header {\n    margin-bottom: 2rem;\n}\n\n.title {\n    margin-bottom: 1rem;\n}\n\n.description {\n    color: var(--text-secondary);\n}\n\n.content {\n    gap: 1rem;\n    margin-top: 1rem;\n}\n\n.item {\n    margin: 0.5rem 0;\n    padding: 0.5rem;\n    border-radius: 4px;\n}\n\n.voteItem {\n    border: 1px solid $grey36;\n    transition: all 0.2s ease;\n\n    &.upvote {\n        border-color: $ocean_blue72;\n        background: rgba($ocean_blue72, 0.05);\n    }\n\n    &.downvote {\n        border-color: $just_say_ok;\n        background: rgba($just_say_ok, 0.05);\n    }\n} \n\n.commentInput {\n    margin-top: 1rem;\n    border: 1px solid $grey36;\n    display: flex;\n}\n\n.headerCard {\n    & > div {\n        padding-bottom: 3rem;\n        min-height: 12rem;\n        & > div:last-child {\n            height: 2.5rem;\n            padding-bottom: 0.5rem;\n            button {\n                margin: 0.5rem;\n            }\n        }\n    }\n}\n\n\n.votesCard, .commentsCard {\n    max-height: 36vh;\n}\n\n\n.rightPanel {\n    padding-bottom: 3rem;\n    justify-content: space-evenly;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__qThVj`,
	"header": `styles_header__qW1tD`,
	"title": `styles_title__THX9i`,
	"description": `styles_description__xzw-8`,
	"content": `styles_content__fKFXO`,
	"item": `styles_item__s6AxQ`,
	"voteItem": `styles_voteItem__qk6Jj`,
	"upvote": `styles_upvote__05cwj`,
	"downvote": `styles_downvote__PXITx`,
	"commentInput": `styles_commentInput__mm96V`,
	"headerCard": `styles_headerCard__DmzDu`,
	"votesCard": `styles_votesCard__mGWSL`,
	"commentsCard": `styles_commentsCard__8dzYj`,
	"rightPanel": `styles_rightPanel__6QSwN`
};
export default ___CSS_LOADER_EXPORT___;
